import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MM04Direction, MM04DirectionLabels } from '../../models/MM04Direction';

@Component({
    selector: 'sera-force-case-direction',
    templateUrl: './sera-force-case-direction.component.html',
    styleUrls: ['./sera-force-case-direction.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraForceCaseDirectionComponent {
    @Input()
    readOnly: boolean = false;

    @Input()
    forceDirection?: MM04Direction | null;

    @Input()
    invalid: boolean = false;

    @Output()
    forceDirectionChanged = new EventEmitter<MM04Direction>();

    isSelectedForceCaseDirection(forceCaseDirection: MM04Direction): boolean {
        return this.forceDirection === forceCaseDirection;
    }

    forceCaseDirectionChange(newForceCaseDirection: MM04Direction) {
        if (this.forceDirection !== newForceCaseDirection) {
            this.forceDirection = newForceCaseDirection;
            this.forceDirectionChanged.emit(newForceCaseDirection);
        }
    }

    protected readonly MM04Direction = MM04Direction;
    protected readonly MM04DirectionLabels = MM04DirectionLabels;
}
